import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import moment from 'moment';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI } from 'src/app/consts/const';
import { Parametri } from 'src/app/models/parametri';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-articoli-consegnati-scadenze-compact',
  templateUrl: './articoli-consegnati-scadenze-compact.component.html',
  styleUrls: ['./articoli-consegnati-scadenze-compact.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxTemplateDirective,
    DxoLookupComponent,
    DxoTextsComponent,
  ],
  standalone: true,
})
export class ArticoliConsegnatiScadenzeCompactComponent
implements OnInit, OnChanges
{
  private navService = inject(NavigatorService);
  private dipendentiService = inject(DipendentiService);
  private parametriService = inject(ParametriService);
  private articoliService = inject(ArticoliService);
  @Input() listConsegneAlert: any;
  @Input() idDipendente;
  @Input() idArticolo;

  dataSource: any;
  listDipendenti: any;
  consegneList: any;
  listArticoli: any;

  //parametri
  parametro: Parametri;
  giorniPreAlertArticoli: number;

  ngOnInit() {
    this.lodLookUp();
    this.getParametro();
  }
  ngOnChanges(changes: SimpleChanges) {
    const consegneChanged =
      changes['listConsegneAlert'] &&
      changes['listConsegneAlert'].currentValue !==
        changes['listConsegneAlert'].previousValue;

    if (this.listConsegneAlert && consegneChanged) {
      this.loadConsegneScadenze();
    }
  }

  lodLookUp() {
    // Dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listDipendenti = res;
        }
      }
    });

    //Articoli
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listArticoli = res.filter(x => x.attivo == true);
        }
      }
    });
  }

  getParametro() {
    this.parametriService.get(PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI).subscribe({
      next: (res) => {
        this.parametro = res;
        this.giorniPreAlertArticoli = this.parametro.valNum;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero parametro');
      },
    });
  }

  loadConsegneScadenze() {
    this.dataSource = new CustomStore({
      key: ['idArticolo', 'idDipendente'],
      load: () => {
        return this.listConsegneAlert;
      },
    });
  }

  onRowPrepared() {
    /*if (e.rowType === 'data' && e.data.dataScadenza) {
      const dataScadenza = moment(e.data.dataScadenza); //, 'YYYY-MM-DD'
      const oggi = moment().format('YYYY-MM-DD');

      if (dataScadenza.isSameOrBefore(oggi, 'day')) {
        // Scadenza oggi o già passata 
        e.rowElement.style.backgroundColor = '#ffcccc';
      } else {
        const diffGiorni = e.dataScadenza.diff(oggi, 'days'); //differenza giorni
        if (diffGiorni > 0 && diffGiorni <= this.giorniPreAlertArticoli) {
          e.rowElement.style.backgroundColor = '#fff3cd';
        }
      }

    }*/
  }

  isScaduto(dataScadenza: Date): boolean {
    if (!dataScadenza) {
      return false;
    }
    const oggi = moment().format('YYYY-MM-DD');
    const scadenza = moment(dataScadenza).format('YYYY-MM-DD');
    return scadenza <= oggi;
  }

  isInScadenza(dataScadenza: Date): boolean {
    if (!dataScadenza) {
      return false;
    }
    const oggi = moment().format('YYYY-MM-DD');
    const diffGiorni = moment(dataScadenza).diff(moment(oggi), 'days');
    //console.log('diff giorni: ' + diffGiorni);
    return diffGiorni > 0 && diffGiorni <= this.giorniPreAlertArticoli;
  }

  goToDipDashboard(e) {
    if (this.idDipendente > 0) {
      this.navService.goToArticoliDashboard(e.idArticolo);
    } else if (this.idArticolo > 0) {
      this.navService.goToDipedenteDashboard(e.idDipendente);
    } else if (!this.idDipendente && !this.idArticolo) {
      this.navService.goToDipedenteDashboard(e.idDipendente);
    }
  }
}
